import { QuickFiltersValueDisplayUses } from '../../types/quickFilters/QuickFiltersValueDisplayUses';
import DisplayValueBoolean from 'customer-data-filters-ui/components/display/DisplayValueBoolean';
import QuickFiltersTags from './QuickFiltersTags';
import { jsx as _jsx } from "react/jsx-runtime";
const QuickFiltersBooleanValueDisplay = props => {
  const {
    condition: {
      value
    },
    onValueDelete,
    use
  } = props;
  const label = /*#__PURE__*/_jsx(DisplayValueBoolean, {
    value: value
  });
  if (use === QuickFiltersValueDisplayUses.STRING) {
    return label;
  }
  const tags = [{
    value: value.toString(),
    label
  }];
  return /*#__PURE__*/_jsx(QuickFiltersTags, {
    tags: tags,
    onTagClose: () => onValueDelete()
  });
};
export default QuickFiltersBooleanValueDisplay;